import React from 'react';

type Props = {
    title: string;
    description?: React.ReactNode;
};

const Title = React.memo(function Title({ title, description = '' }: Props) {
    return (
        <div className="title-container" data-testid="title">
            <h2 className="mb-l5-16 form-title">{title}</h2>
            {description && <h5 data-testid="description">{description}</h5>}
        </div>
    );
});

export default Title;
